<card class="mb-0">

    <div class="container" *ngIf="!post; else forminfo">
        <form [formGroup]="analysisFormGroup" (ngSubmit)="onSubmit(analysisFormGroup.value)" novalidate>

            <div class="row">
                <div class="col-md-9 my-3">
                    <mat-form-field>
                        <mat-select placeholder="Analysis Type" formControlName="analysisType"
                            (ngModelChange)="resetAnalysis()" required disableOptionCentering>
                            <mat-option value="ADA">Cut Point & Sensitivity Report</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

        </form>


        <form [formGroup]="analysisFormGroup_ADA" (ngSubmit)="onSubmit(analysisFormGroup_ADA.value)" novalidate>
            <div *ngIf="analysisFormGroup.value.analysisType == 'ADA'">
                <div class="row">
                    <div class="col-md-9 my-3">
                        <mat-form-field>
                            <mat-label>Analysis Subtype</mat-label>
                            <mat-select #val formControlName="analysisSubtype" required disableOptionCentering>
                                <mat-option *ngFor="let obj of getDropDownValues('analysisSubtype_ADA')"
                                    [value]="obj.name">
                                    {{obj.desc}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
    
                <div class="row" *ngIf="analysisFormGroup_ADA.value.analysisSubtype =='Sensitivity'">
                    <div class="col-md-9">
                        <mat-form-field>
                            <mat-label>Sensitivity Type</mat-label>
                            <mat-select formControlName="ada_subtype" required disableOptionCentering>
                                <mat-option *ngFor="let obj of getDropDownValues('ada_subtype')" [value]="obj.name">
                                    {{obj.desc}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row" *ngIf="analysisFormGroup_ADA.value.analysisSubtype =='Cut Point'">
                    <div class="col-md-9">
                        <mat-form-field>
                            <mat-label>Cut Point Type</mat-label>
                            <mat-select formControlName="ada_subtype" required disableOptionCentering>
                                <mat-option *ngFor="let obj of getDropDownValues('ada_subtype')" [value]="obj.name">
                                    {{obj.desc}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row" *ngIf="analysisFormGroup_ADA.value.analysisSubtype =='Cut Point & Sensitivity'">
                    <div class="col-md-9">
                        <mat-form-field>
                            <mat-label>Cut Point & Sensitivity Type</mat-label>
                            <mat-select formControlName="ada_subtype"
                                required disableOptionCentering>
                                <mat-option *ngFor="let obj of getDropDownValues('ada_subtype')" [value]="obj.name">
                                    {{obj.desc}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row"
                    *ngIf="analysisFormGroup_ADA.value.analysisSubtype =='Sensitivity' && analysisFormGroup_ADA.value.ada_subtype == 'Screening'">
                    <div class="col-md-9">
                        <mat-form-field>
                            <mat-label>Screening Cut Point</mat-label>
                            <input matInput formControlName="screening_cutpoint"
                                required
                                [ngClass]="{ 'is-invalid': analysisFormGroup_ADA.controls['screening_cutpoint'].hasErrors }">
                            <mat-error *ngIf="analysisFormGroup_ADA.controls['screening_cutpoint'].errors"
                                class="invalid-feedback error">
                                <div *ngIf="analysisFormGroup_ADA.controls['screening_cutpoint'].errors.pattern">
                                    <strong>Numeric</strong> only
                                </div>
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row"
                    *ngIf="analysisFormGroup_ADA.value.analysisSubtype =='Sensitivity' && analysisFormGroup_ADA.value.ada_subtype == 'Confirmatory'">
                    <div class="col-md-9">
                        <mat-form-field>
                            <mat-label>Confirmatory Cut Point</mat-label>
                            <input matInput type="text"
                                formControlName="confirmatory_cutpoint" required>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row"
                    *ngIf="analysisFormGroup_ADA.value.analysisSubtype =='Sensitivity' && analysisFormGroup_ADA.value.ada_subtype == 'Screening & Confirmatory'">
                    <div class="col-md-6">
                        <mat-form-field>
                            <mat-label>Screening Cut Point</mat-label>
                            <input matInput formControlName="screening_cutpoint"
                                required
                                [ngClass]="{ 'is-invalid': analysisFormGroup_ADA.controls['screening_cutpoint'].hasErrors }">
                            <mat-error *ngIf="analysisFormGroup_ADA.controls['screening_cutpoint'].errors"
                                class="invalid-feedback error">
                                <div *ngIf="analysisFormGroup_ADA.controls['screening_cutpoint'].errors.pattern">
                                    <strong>Numeric</strong> only
                                </div>
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field>
                            <mat-label>Confirmatory Cut Point</mat-label>
                            <input matInput type="text"
                                formControlName="confirmatory_cutpoint" required>
                        </mat-form-field>
                    </div>
                </div>


                <div class="row">
                    <div class="col-md-9 my-3">
                        <mat-form-field>
                            <mat-label>Analyte Name</mat-label>
                            <input matInput type="text" formControlName="analyteNames" required>
                        </mat-form-field>
                    </div>
                </div>


                <div class="row">
                    <div class="col-md-9 my-3">
                        <mat-form-field>
                            <mat-label>Project Code</mat-label>
                            <input matInput formControlName="projectCodeSA" required
                                [ngClass]="{ 'is-invalid': analysisFormGroup_ADA.controls['projectCodeSA'].hasErrors }">
                            <mat-error *ngIf="analysisFormGroup_ADA.controls['projectCodeSA'].errors"
                                class="invalid-feedback error">
                                <div *ngIf="analysisFormGroup_ADA.controls['projectCodeSA'].errors.pattern">
                                    Must be <strong>Alphanumeric</strong>
                                </div>
                            </mat-error>
                        </mat-form-field>

                    </div>
                    <div class="col-md-6 my-3"
                         *ngIf="analysisFormGroup_ADA.value.analysisSubtype && analysisFormGroup_ADA.value.analysisSubtype.indexOf('Cut Point') !== -1">
                        <mat-form-field>
                            <mat-label>Tukey Coefficient(1.5,2,2.5,3)</mat-label>
                            <input matInput type="number" formControlName="tukeyCoefficient">
                            <mat-error *ngIf="analysisFormGroup_ADA.controls['tukeyCoefficient'].errors">
                                Must be a positive number.
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 my-3">
                        <mat-form-field>
                            <mat-label>Starting Concentration (Required for Watson ADA Format)</mat-label>
                            <input matInput type="number" formControlName="startingConc">
                            <mat-error *ngIf="analysisFormGroup_ADA.controls['startingConc'].errors">
                                Must be a positive number.
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 my-3">
                        <mat-form-field>
                            <mat-label>Concentration Unit</mat-label>
                            <mat-select #val formControlName="concentrationUnit" required disableOptionCentering>
                                <mat-option *ngFor="let obj of getDropDownValues('concentrationUnit')"
                                    [value]="obj.name">
                                    {{obj.desc}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row" *ngIf="analysisFormGroup_ADA.value.analysisSubtype">
                    <div class="col-md-10">
                        <mat-expansion-panel>
                            <mat-expansion-panel-header class="py-3">
                                Advanced Options
                            </mat-expansion-panel-header>
                            <div class="form-subsection p-4 m-4">
                                <p class="subsection-label mt-2">Filtering Options</p>
                                <div class="row mb-4" *ngIf="analysisFormGroup_ADA.value.analysisSubtype.indexOf('Cut Point') !== -1">
                                    <div class="m-3 col-md-4">
                                        <mat-form-field>
                                            <mat-label>Cut Point CV Threshold</mat-label>
                                            <mat-select formControlName="CVThreshold">
                                                <mat-option value="20">20</mat-option>
                                                <mat-option value="25">25</mat-option>
                                                <mat-option value="30">30</mat-option>
                                                <mat-option value="none">None</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row mb-4">
                                    <div class="m-3 col-md-4">
                                        <mat-form-field>
                                            <mat-label>Filter NC Values by CV</mat-label>
                                            <mat-select formControlName="filterNC">
                                                <mat-option value="True">True </mat-option>
                                                <mat-option value="False">False</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="m-3 col-md-4" *ngIf="analysisFormGroup_ADA.value.filterNC == 'True'">
                                        <mat-form-field>
                                            <mat-label>NC CV Threshold</mat-label>
                                            <mat-select formControlName="NCThreshold">
                                                <mat-option value="20">20</mat-option>
                                                <mat-option value="25">25</mat-option>
                                                <mat-option value="30">30</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row mb-4" *ngIf="analysisFormGroup_ADA.value.analysisSubtype.indexOf('Sensitivity') !== -1">
                                    <div class="m-3 col-md-4">
                                        <mat-form-field>
                                            <mat-label>Filter Sensitivity Values by CV</mat-label>
                                            <mat-select formControlName="filterSensitivity">
                                                <mat-option value="True">True </mat-option>
                                                <mat-option value="False">False</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="m-3 col-md-4" *ngIf="analysisFormGroup_ADA.value.filterSensitivity == 'True'">
                                        <mat-form-field>
                                            <mat-label>Sensitivity CV Threshold</mat-label>
                                            <mat-select formControlName="sensThreshold">
                                                <mat-option value="20">20</mat-option>
                                                <mat-option value="25">25</mat-option>
                                                <mat-option value="30">30</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="form-subsection p-4 m-4">
                                <p class="subsection-label">Analytical Workflow Options</p>
                                <div class="row mb-4">
                                    <div class="m-3 col-md-4" *ngIf="analysisFormGroup_ADA.value.analysisSubtype.indexOf('Sensitivity') !== -1">
                                        <mat-form-field>
                                            <mat-label>Regression Type</mat-label>
                                            <mat-select formControlName="regType">
                                                <mat-option value="4pl">4 PL</mat-option>
                                                <mat-option value="5pl">5 PL</mat-option>
                                                <mat-option value="4pl+5pl">4 PL + 5 PL</mat-option>
                                                <mat-option value="linear">Linear</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="m-3 col-md-4" *ngIf="analysisFormGroup_ADA.value.analysisSubtype.indexOf('Cut Point') !== -1">
                                        <mat-form-field>
                                            <mat-label>NAB Dataset</mat-label>
                                            <mat-select formControlName="nabDataset">
                                                <mat-option value="Yes">Yes</mat-option>
                                                <mat-option value="No">No</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="m-3 col-md-4">
                                        <mat-form-field>
                                            <mat-label>NC Calculation Method</mat-label>
                                            <mat-select formControlName="NCMethod">
                                                <mat-option value="GM">Geometric Mean</mat-option>
                                                <mat-option value="AM">Arithmetic Mean</mat-option>
                                                <mat-option value="MED">Median</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="m-3 col-md-4 with-tooltip">
                                        <mat-form-field>
                                            <mat-label>NC Means vs Replicates</mat-label>
                                            <mat-select formControlName="NCReps">
                                                <mat-option value="Mean of Means">Mean of Means</mat-option>
                                                <mat-option value="Mean of Replicates">Mean of All Replicates</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <span class="helper-text">
                                            Select whether to average replicates between samples before calculating (Mean of Means), or to use all replicates (Mean of All Replicates)
                                        </span>
                                    </div>
                                    <div class="m-3 col-md-4">
                                        <mat-form-field>
                                            <mat-label>NC Outlier Removal</mat-label>
                                            <mat-select formControlName="NCOutlierOption">
                                                <mat-option value="True">True </mat-option>
                                                <mat-option value="False">False</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="m-3 col-md-4"
                                            *ngIf="analysisFormGroup_ADA.value.analysisSubtype && analysisFormGroup_ADA.value.analysisSubtype.indexOf('Cut Point') !== -1 && analysisFormGroup_ADA.value.ada_subtype && analysisFormGroup_ADA.value.ada_subtype.indexOf('Screening') !== -1">
                                        <mat-form-field>
                                            <mat-label>Screening Cut Point False Positive Rate</mat-label>
                                            <mat-select formControlName="FPR">
                                                <mat-option value="5%">5% FPR</mat-option>
                                                <mat-option value="1%">1% FPR</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="m-3 col-md-4" *ngIf="analysisFormGroup_ADA.value.analysisSubtype.indexOf('Cut Point') !== -1">
                                        <mat-form-field>
                                            <mat-label>Outlier Removal</mat-label>
                                            <mat-select formControlName="outlierRemoval">
                                                <mat-option value="All">All</mat-option>
                                                <mat-option value="biological outliers only">Biological Outliers Only</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="m-3 col-md-4" *ngIf="analysisFormGroup_ADA.value.analysisSubtype.indexOf('Sensitivity') !== -1">
                                        <mat-form-field>
                                            <mat-label>LPC Critical value</mat-label>
                                            <mat-select formControlName="LPCCriticalvalue">
                                                <mat-option value="t0.01">t0.01 </mat-option>
                                                <mat-option value="t0.005">t0.005</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="form-subsection p-4 m-4">
                                <p class="subsection-label" *ngIf="analysisFormGroup_ADA.value.analysisSubtype.indexOf('Cut Point') !== -1">Transformation Options</p>
                                <div class="row mb-4" *ngIf="analysisFormGroup_ADA.value.analysisSubtype.indexOf('Cut Point') !== -1">
                                    <div class="m-3 col-md-4">
                                        <mat-form-field>
                                            <mat-label>Auto Log Transform</mat-label>
                                            <mat-select formControlName="autoLogTransform">
                                                <mat-option value="False">False </mat-option>
                                                <mat-option value="True">True</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="m-3 col-md-4">
                                        <mat-form-field>
                                            <mat-label>Log Transformation Function</mat-label>
                                            <mat-select formControlName="logFunc">
                                                <mat-option value="natural log">Natural Log </mat-option>
                                                <mat-option value="base 10">Base 10</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="form-subsection p-4 m-4">
                                <p class="subsection-label">Miscellaneous Options</p>
                                <div class="row">
                                    <div class="m-3 col-md-4">
                                        <mat-form-field>
                                            <mat-label>Decimal Points</mat-label>
                                            <mat-select formControlName="decimalPoints">
                                                <mat-option value="2">2</mat-option>
                                                <mat-option value="3">3</mat-option>
                                                <mat-option value="5">5</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </div>
                </div>
            </div>

            <div *ngIf="analysisFormGroup.value.analysisType=='ADA'" class="my-5">
                <button class="btn btn-primary m-1" color="primary" type="submit"
                    [disabled]="(!analysisFormGroup_ADA.valid)">Submit Form
                </button>
            </div>
        </form>


        <br>
        <br><br>

    </div>

    <ng-template #forminfo>
        <div class="row">
            <div class="col-md-6"><strong>Analysis Type:</strong>
                {{getDisplayString(analysisDetails.analysisType)}} </div>

        </div>
        <br>


        <div *ngIf="analysisDetails.analysisType=='ADA'">
            <div class="row">

                <div class="col-md-6"><strong>Analyte Name: </strong>{{analysisDetails.analyteNames}}</div>
                <div class="col-md-6"><strong>Analyte Subtype: </strong>{{analysisDetails.analysisSubtype}}</div>
                <div class="col-md-6" *ngIf="analysisDetails.analysisSubtype == 'Sensitivity'"><strong>Sensitivity Type:
                    </strong>{{analysisDetails.ada_subtype}}</div>

                <div class="col-md-6"
                    *ngIf="analysisDetails.ada_subtype == 'Screening' && analysisDetails.analysisSubtype == 'Sensitivity'">
                    <strong>Screening Cutpoint: </strong>{{ analysisDetails.screening_cutpoint }}</div>
                <div class="col-md-6"
                    *ngIf="analysisDetails.ada_subtype == 'Confirmatory' && analysisDetails.analysisSubtype == 'Sensitivity'">
                    <strong>Confirmatory Cutpoint: </strong>{{ analysisDetails.confirmatory_cutpoint }}</div>
                <div class="col-md-6"
                    *ngIf="analysisDetails.ada_subtype == 'Screening & Confirmatory' && analysisDetails.analysisSubtype == 'Sensitivity'">
                    <strong>Screening Cutpoint: </strong>{{ analysisDetails.screening_cutpoint }}
                </div>
                <div class="col-md-6"
                    *ngIf="analysisDetails.ada_subtype == 'Screening & Confirmatory' && analysisDetails.analysisSubtype == 'Sensitivity'">
                    <strong>Confirmatory Cutpoint: </strong>{{ analysisDetails.confirmatory_cutpoint }}
                </div>
                <div class="col-md-6" *ngIf="analysisDetails.analysisSubtype == 'Cut Point'">
                    <strong>Cut Point Type: </strong>{{ analysisDetails.ada_subtype }}</div>
                <div class="col-md-6" *ngIf="analysisDetails.analysisSubtype == 'Cut Point & Sensitivity'">
                    <strong>Cut Point & Sensitivity Type: </strong>{{ analysisDetails.ada_subtype }}</div>
                <div class="col-md-6"><strong>Project Code:</strong> {{analysisDetails.projectCodeSA}}</div>
                <div class="col-md-6" *ngIf="analysisDetails.analysisSubtype && analysisFormGroup_ADA.value.analysisSubtype.indexOf('Cut Point') !== -1">
                    <strong>Tukey Coefficient: </strong>{{analysisDetails.tukeyCoefficient}}
                </div>
                <div class="col-md-6" *ngIf="analysisDetails.startingConc !== ''"><strong>Starting Concentration: </strong>{{analysisDetails.startingConc}}</div>
                <div class="col-md-6"><strong>Concentration Unit: </strong>{{ analysisDetails.concentrationUnit }}</div>
                <div class="col-md-6" *ngIf="analysisDetails.analysisSubtype === 'Sensitivity' || analysisDetails.analysisSubtype === 'Cut Point & Sensitivity'">
                    <strong>Regression Type: </strong>
                    {{ analysisDetails.regType }}
                </div>
                <div class="col-md-6"><strong>NAB Dataset:
                    </strong>{{analysisDetails.nabDataset}}
                </div>
                <div class="col-md-6"><strong>Cut Point CV Threshold:
                    </strong>{{analysisDetails.CVThreshold}}
                </div>
                <div class="col-md-6"><strong>Filter NC Values by CV:
                    </strong>{{analysisDetails.filterNC}}
                </div>
                <div class="col-md-6" *ngIf="analysisDetails.filterNC == 'True'"><strong>NC CV Threshold:
                    </strong>{{analysisDetails.NCThreshold}}
                </div>
                <div class="col-md-6" *ngIf="analysisDetails.analysisSubtype =='Sensitivity' || analysisDetails.analysisSubtype =='Cut Point & Sensitivity'"><strong>Filter Sensitivity Values by CV:
                    </strong>{{analysisDetails.filterSensitivity}}
                </div>
                <div class="col-md-6" *ngIf="analysisDetails.analysisSubtype.indexOf('Sensitivity') !== -1 && analysisDetails.filterSensitivity == 'True'"><strong>Sensitivity CV Threshold:
                    </strong>{{analysisDetails.sensThreshold}}
                </div>
                <div class="col-md-6"><strong>NC Calculation Method:
                    </strong>{{analysisDetails.NCMethod}}
                </div>
                <div class="col-md-6"><strong>NC Means vs Replicates:
                    </strong>{{analysisDetails.NCReps}}
                </div>
                <div class="col-md-6"><strong>NC Outlier Removal:
                    </strong>{{analysisDetails.NCOutlierOption}}
                </div>
                <div class="col-md-6" *ngIf="analysisDetails.analysisSubtype && analysisFormGroup_ADA.value.analysisSubtype.indexOf('Cut Point') !== -1 && analysisDetails.ada_subtype && analysisDetails.ada_subtype.indexOf('Screening') !== -1"><strong>Screening Cut Point False Positive Rate:
                    </strong>{{analysisDetails.FPR}}
                </div>
                <div class="col-md-6"><strong>Outlier Removal:
                    </strong>{{analysisDetails.outlierRemoval}}
                </div>
                <div class="col-md-6" *ngIf="analysisDetails.analysisSubtype =='Sensitivity' || analysisDetails.analysisSubtype =='Cut Point & Sensitivity'"><strong>LPC Critical Value:
                    </strong>{{analysisDetails.LPCCriticalvalue}}
                </div>
                <div class="col-md-6"><strong>Auto Log Transform:
                    </strong>{{analysisDetails.autoLogTransform}}
                </div>
                <div class="col-md-6"><strong>Log Transformation Function:
                    </strong>{{analysisDetails.logFunc}}
                </div>
                <div class="col-md-6"><strong>Decimal Points:
                    </strong>{{analysisDetails.decimalPoints}}
                </div>
            </div>
        </div>

        <app-doc-upload [analysisDetails]="analysisDetails"></app-doc-upload>
    </ng-template>
</card>
